export const motivosColaboradores = [
  "Atestado Médico",
  "Consulta / Exame Médico",
  "Acompanhamento Médico Familiar",
  "Problema de Saúde",
  "Motivo Pessoal",
  "Serviço Eleitoral",
  "Convocação Judicial",
  "Luto / Falecimento em Família",
  "Licença Gala / Casamento",
  "Treinamento / Capacitação",
  "Impossibilidade de Deslocamento / Intempérie",
  "Outros",
];

export default motivosColaboradores;
